
import { IEvent } from "../../../models/Event"

export const EgudCmp: React.FC<{ event: IEvent }> = ({ event }) => {


    return (
        <section className="section section--tight">
            <div className="container">
                <div className="egud-box">
                    <img src="https://www.4sport-live.com/media/minisite/7/SeSCIdbWPhoeYECc_rsz_1tav_igud_haatletika.png" alt="תו תקן איגוד האתלטיקה" />
                    <p>
                    המרוץ מוכר כבעל תקן באיגוד האתלטיקה ולכן זוכה לסיוע מקצועי צמוד והכרה רשמית בתוצאותיו.
                    מדידת מסלול המרוץ נעשית ע"י מודד מוסמך מטעם ה - AIMS.
                    </p>
                </div>
            </div>
        </section>
    )
}
